import { registerFunctionalComponent } from 'js/lib/components/component'
import { on } from 'js/lib/events'
import { CHECKOUT_STEP_EVENT } from '../events'

registerFunctionalComponent('.js-c-payments-checkout-form', 'CheckoutFormComponent', CheckoutFormComponent)

function CheckoutFormComponent(component) {
  const wrapper = component.element
  const frameKey = wrapper.dataset.frameKey
  let lastStep = null

  const announceCurrentStep = () => {
    const currentStep = wrapper.querySelector('.js-c-payments-checkout-form__current-step')
    if (!currentStep) return

    const { step } = currentStep.dataset
    if (step === lastStep) return

    if (lastStep) {
      wrapper.querySelector('[data-step-progress-step][aria-current="step"]')?.focus({ preventScroll: true })
    }

    lastStep = step
    wrapper.dispatchEvent(new CustomEvent(CHECKOUT_STEP_EVENT, { bubbles: true, detail: { stepName: step } }))
  }

  announceCurrentStep()

  const removeRequestEndListener = on('dynamic-frame:request-end', document, event => {
    const { frameKey: updatedFrameKey, status } = event.detail || {}
    if (updatedFrameKey === frameKey && status === 'succeeded') announceCurrentStep()
  })
  const stepObserver = new MutationObserver(announceCurrentStep)
  stepObserver.observe(wrapper, { childList: true, subtree: true })

  component.useHandler(() => () => {
    stepObserver.disconnect()
    removeRequestEndListener()
  })
}
